import { Outlet } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import Button from '@mui/material/Button/Button';
import { login } from '../services/auth.service';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { GlassBox } from '../components/ui';
import Typography from '@mui/material/Typography';
export const PrivateRoutes = () => {

    const { user, loading } = useAuth();

    if (loading) {
        return <></>;
    }

    if (!user) {
        return <div
            style={{
                height: 'calc(100vh - 87px)',
                position: 'relative',
                justifyContent: 'center',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                backgroundColor: 'rgba(255, 255, 255, 0.8)'
            }}>

            <Box sx={{
                backgroundImage: "url('/assets/error.webp')",
                color: '#f0f0f0', backgroundSize: 'cover',
                backgroundPosition: 'center',
                height: 400,
                width: 400,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
                borderRadius: 8,
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.5)'
            }}>
                <GlassBox opacity={0.1} sx={{ p: 3, textAlign: 'center' }}>
                    <Stack spacing={1} alignItems="center">
                        <Typography variant='body1' >You must be logged in to view this page.</Typography>
                        <Button variant='contained' onClick={() => {
                            login();
                        }}>Login/Signup</Button>
                    </Stack>
                </GlassBox>
            </Box>
        </div>;

    }

    return (
        <Outlet />
    );
};
